import { TableContainer, TableHead, TableRow } from "@mui/material";
import styled from "styled-components";
import { Box, IconButton } from '@mui/material';

interface SortIconButtonProps {
  active?: boolean;
}

export const StyledTableContainer = styled(TableContainer)`
  max-height: 450px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.base};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media (max-width: 1000px) {
    border-radius: 0;
  }
`;

export const StyledTableHead = styled(TableHead)`
  background-color: #f5f5f5;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const StyledTableRow = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: #fafafa;
  }

  &:hover {
    background-color: #dddddd;
  }

  td {
    padding: 12px 16px;
  }
`;

export const SortableColumn = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  position: relative;
  user-select: none;

  &:hover {
    .sort-icon {
      opacity: 1;
    }
  }
`;

export const SortIconButton = styled(IconButton)<SortIconButtonProps>`
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: opacity 0.3s ease;
  pointer-events: none;
`;
